<template>

	<div class="deep-link-controller"></div>

</template>


<script>

import featureMixin from "@/mixins/featureMixin";

import {mapGetters, mapActions} from "vuex";

export default {

	name: "DeepLinkController",
	mixins: [featureMixin],

	data() {
		return {
			waysToSave: '',
			category: '',
			savings: 0,
			search: ''
		}
	},

	computed: {
		...mapGetters('filters', ["filtersByName"]),
		...mapGetters(['productsBySKU']),

	},

	methods: {
		...mapActions('filters', ["setFilterPanelState"]),
		...mapActions('pdp', ['open']),
		checkShowPDP() {
			const showPdp = this.$route?.query?.showPDP === '1';
			const sku = this.$route?.hash?.split('#').find((item) => {
				return item.includes('sku=');
			})?.replace('sku=', '');
		    if(showPdp && sku) {
				this.open(this.productsBySKU[sku]);
		    }
		}
	},

	mounted() {
		this.search = this.$route.query?.searchTerm;
		const categoryParam = decodeURIComponent(this.$route.fullPath?.match(/category=(.*)/)?.[1]);
		this.category = categoryParam.includes('&') ? categoryParam : this.$route.query?.category;
		this.savings = this.$route.query?.savings;
		this.waysToSave = this.$route.query?.waysToSave;

		if (this.search) {
			this.filtersByName['text'].value = this.search;
			this.openFilterPanel
		}

		if (this.category) {
			const sections = this.filtersByName['category']?.sections;
			sections?.forEach((section) => {
				section?.items?.forEach((item) => {

					if (item?.label.toUpperCase() === this.category.toUpperCase()) {
						item.checkbox.selected = true;
					}

					item?.subItems?.forEach((subItem) => {
						if (subItem.label === this.category.toUpperCase()) {
							subItem.checkbox.selected = true
							
						}
					})
				})
			})
		}

		if (this.savings) {
			let saving = this.filtersByName['saving']?.items;
			if (this.filtersByName['saving']) {
				saving.forEach((saving) => {
					if (saving.label.includes(this.savings)) {
						saving.selected = true;
					}
				})
			}
		}

		if (this.waysToSave) {
			let waysToSave = this.filtersByName['waysToSave']?.sections[0]
			waysToSave.items.forEach((item) => {
				if (item.label.toUpperCase() === this.waysToSave.toUpperCase()) {
					item.checkbox.selected = true;
				}
			})
		}

		this.$nextTick(() => {
           setTimeout(() => {
            this.checkShowPDP();
           }, 1100)
        })
	}
}

</script>


<style scoped>

.deep-link-controller {
	display: none;
}

</style>
